module.exports = __webpack_public_path__ + "static/media/accesories.33050be3.png";